import { render } from "./List.pug?vue&type=template&id=1974100c&ts=true&lang=pug&external"
import script from "./List.ts?vue&type=script&lang=ts&external"
export * from "./List.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/companies/List.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1974100c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1974100c', __exports__)) {
    api.reload('1974100c', __exports__)
  }
  
  module.hot.accept("./List.pug?vue&type=template&id=1974100c&ts=true&lang=pug&external", () => {
    api.rerender('1974100c', render)
  })

}


export default __exports__